import axios from "axios";
import React, { useState } from "react";
import { backendBookartUrl } from "../library/constants";
import { Button, Modal } from "react-bootstrap";
import Popup from '../components/Popup';

const EditData = (props) => {
  const { email_address } = props.data;

  const [data, setData] = useState(props.data);
  const [uneditable, setUneditable] = useState(true);
  const [isResult, setIsResult] = useState(false);
  const [show, setShow] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupMessage, setPopupMessage] = useState('');

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const deleteData = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    var data = JSON.stringify({ email: email_address });
    var config = {
      method: "post",
      url: `${backendBookartUrl}/customer_delete?=`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        if (response.data.status === "success") {
          setIsResult(true);
          handleShowPopup('Delete User', "User Deleted Successfully");
        }
      })
      .catch((err) => {
        setIsResult(true);
        handleShowPopup('Delete User', err.response.data.message);
        console.log(err);
      });
  };

  const editData = (event) => {
    let sendableData = {
      account_number: data.account_number,
      alternate_contact_number: data.alternate_contact_number,
      alternate_email_id: data.alternate_email_id,
      bill_to_address: data.bill_to_address,
      city: data.city,
      individual_name: data.individual_name,
      contact_number: data.contact_number,
      customer_name: data.customer_name,
      email_address: data.email_address,
      pincode: data.pincode,
      sales_emailid: data.sales_emailid,
      ship_to_address: data.ship_to_address,
      onboard_status: data.onboard_status,
      state: data.state,
    };

    const token = window.sessionStorage.getItem("JWTtoken");
    var requestData = JSON.stringify(sendableData);
    var config = {
      method: "post",
      url: `${backendBookartUrl}/customer_update?=`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: requestData,
    };

    if (event.target.name === "edit") {
      setUneditable(false);
    } else if (event.target.name === "update") {
      axios(config)
        .then((response) => {
          setIsResult(true);
          handleShowPopup('Edit User', response.data.message);
        })
        .catch((error) => {
          setIsResult(true);
          console.log("error", error);
          handleShowPopup('Edit User', error.response.data.message);
        });
    }
  };

  const handleShowPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      {isResult ? (
        <Popup
          title={popupTitle}
          message={popupMessage}
          show={showPopup}
          handleClose={handleClosePopup}
        />
      ) : (
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="col-6 margin-top-30">
              <p><label>Customer Name</label></p>
              <p>
                <input
                  type="text"
                  className="es-input"
                  placeholder="Customer name"
                  name="customer_name"
                  value={data.customer_name}
                  readOnly={uneditable}
                  onChange={(e) => setData({ ...data, customer_name: e.target.value })}
                  required={true}
                />
              </p>
            </div>
            <div className="col-6 margin-top-30">
              <p><label>Account Number</label></p>
              <p>
                <input
                  type="number"
                  className="es-input"
                  placeholder="Account number"
                  name="account-number"
                  value={data.account_number}
                  readOnly={true}
                  required={true}
                  disabled={true}
                />
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-6 margin-top-30">
              <p><label>Individual Name</label></p>
              <p>
                <input
                  type="text"
                  className="es-input"
                  placeholder="Individual name"
                  value={data.individual_name}
                  readOnly={uneditable}
                  required={true}
                  onChange={(e) => setData({ ...data, individual_name: e.target.value })}
                />
              </p>
            </div>
            <div className="col-6 margin-top-30">
              <p><label>Onboard Status</label></p>
              <p>
                <input
                  type="text"
                  className="es-input"
                  placeholder="Onboard status"
                  value={data.onboard_status}
                  readOnly={true}
                  disabled={true}
                />
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-6 margin-top-30">
              <p><label>Customer Email ID</label></p>
              <p>
                <input
                  type="email"
                  className="es-input"
                  placeholder="Enter email"
                  value={data.email_address}
                  required={true}
                  readOnly={true}
                  disabled={true}
                />
              </p>
            </div>
            <div className="col-6 margin-top-30">
              <p><label>Alternate Email ID</label></p>
              <p>
                <input
                  type="email"
                  className="es-input"
                  placeholder="Enter email"
                  value={data.alternate_email_id}
                  onChange={(e) => setData({ ...data, alternate_email_id: e.target.value })}
                  readOnly={uneditable}
                />
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-6 margin-top-30">
              <p><label htmlFor="phone">Primary Contact Number</label></p>
              <p>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  className="es-input"
                  placeholder="Contact number"
                  value={data.contact_number}
                  readOnly={uneditable}
                  onChange={(e) => setData({ ...data, contact_number: e.target.value })}
                />
              </p>
            </div>
            <div className="col-6 margin-top-30">
              <p><label htmlFor="alternate_phone">Alternate Contact Number</label></p>
              <p>
                <input
                  type="text"
                  id="alternate_phone"
                  name="phone"
                  className="es-input"
                  placeholder="Contact number"
                  value={data.alternate_contact_number}
                  readOnly={uneditable}
                  onChange={(e) => setData({ ...data, alternate_contact_number: e.target.value })}
                />
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-12 margin-top-30">
              <p><label>Sales Email ID</label></p>
              <p>
                <input
                  type="text"
                  className="es-input"
                  placeholder="Sales email"
                  value={data.sales_emailid}
                  readOnly={uneditable}
                  onChange={(e) => setData({ ...data, sales_emailid: e.target.value })}
                />
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-6 margin-top-30">
              <p>
                <label>
                  Shipping Address{" "}
                  <span style={{ fontSize: "14px" }}>
                    {"(Make sure to add ~ before adding new address)"}
                  </span>
                </label>
              </p>
              <p>
                <textarea
                  className="es-input"
                  rows="4"
                  value={data.ship_to_address}
                  readOnly={uneditable}
                  onChange={(e) => setData({ ...data, ship_to_address: e.target.value })}
                  style={{ width: "100%" }}
                />
              </p>
            </div>
            <div className="col-6 margin-top-30">
              <p>
                <label>
                  Billing Address{" "}
                  <span style={{ fontSize: "14px" }}>
                    {"(Make sure to add ~ before adding new address)"}
                  </span>
                </label>
              </p>
              <p>
                <textarea
                  className="es-input"
                  rows="4"
                  value={data.bill_to_address}
                  readOnly={uneditable}
                  onChange={(e) => setData({ ...data, bill_to_address: e.target.value })}
                  style={{ width: "100%" }}
                />
              </p>
            </div>
          </div>

          <div className="flex-space-between margin-top-30">
            <button
              onClick={editData}
              name={uneditable ? "edit" : "update"}
              className="es-button primary"
            >
              {uneditable ? "Edit" : "Update"}
            </button>
            <>
              <button className="es-button danger" onClick={handleShow}>
                Delete
              </button>

              <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Delete User</Modal.Title>
                </Modal.Header>
                <Modal.Body>Confirm, to delete user</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                  <Button variant="danger" onClick={deleteData}>
                    Delete User
                  </Button>
                </Modal.Footer>
              </Modal>
            </>
          </div>
        </form>
      )}
    </>
  );
};

export default EditData;
